import { Component, ErrorInfo, ReactNode } from 'react';
import { logger } from './logger';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    logger.error(error, {
      source: 'react-error-boundary',
      componentStack: info.componentStack ?? '',
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        this.props.fallback ?? (
          // Inline style intentional: this last-resort fallback renders after the
          // app has crashed and must not depend on any app CSS (which could be the
          // cause). Pass `fallback` to fully customize. (overrides CLAUDE.md no-inline-CSS)
          <div
            role="alert"
            style={{
              padding: '2rem',
              fontFamily: 'sans-serif',
              textAlign: 'center',
            }}
          >
            <h1>An error has occurred</h1>
            <p>The team has been notified. Please reload the page.</p>
            <button type="button" onClick={() => window.location.reload()}>
              Reload
            </button>
          </div>
        )
      );
    }
    return this.props.children;
  }
}
